import { Controller } from "react-hook-form";
import { Plus } from "lucide-react";
import { Select } from "../ui";
import { openModal } from "../../_app/entityModals/store";

/**
 * Dedupes what used to be an identical FormInputSingleSelect "Usage
 * compilations" block hand-written in both PlanFormBody and
 * ProductFormBody - same duplication shape MarketSelect.jsx already
 * dedupes for Market. `onChange` reports the full usage-compilation
 * object (not just its id) - callers need `usageCompilations.title` for
 * the wallet-credits label and preview.
 *
 * "+ Add new usage compilation" uses Select's `footerAction` (see
 * MarketSelect.jsx's identical comment for why - a persistent row pinned
 * below the scrollable option list, not a plain entry in `options` that
 * gets buried once enough real compilations exist).
 *
 * The created compilation shows correctly via `selectedLabel` even
 * before `createUsageCompilation`'s "UsageCompilations" tag invalidation
 * refetches this list's own query (both callers here use
 * `useGetUsageCompilationsQuery`, org-wide - no manual refetch wiring
 * needed).
 */
const UsageCompilationSelect = ({
  control,
  name = "usageCompilations",
  usageCompilations = [],
  label = "Usage compilations",
  rules,
  trigger,
  disabled = false,
  tooltip,
}) => {
  const options = usageCompilations.map((compilation) => ({ label: compilation.title, value: compilation._id }));

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <Select
          id={name}
          label={label}
          options={options}
          value={field.value?._id}
          selectedLabel={field.value?.title}
          onChange={(value) => {
            const selected = usageCompilations.find((compilation) => compilation._id === value) || null;
            field.onChange(selected);
            trigger?.(name);
          }}
          onBlur={field.onBlur}
          error={fieldState.error?.message}
          disabled={disabled}
          tooltip={tooltip}
          footerAction={
            disabled
              ? undefined
              : {
                  label: "Add new usage compilation",
                  icon: Plus,
                  onClick: async () => {
                    const created = await openModal("create_usage_compilation");
                    if (created) {
                      field.onChange(created);
                      trigger?.(name);
                    }
                  },
                }
          }
        />
      )}
    />
  );
};

export default UsageCompilationSelect;
